const signup = {
  invalidToken: 'Ficha de invitación no válida. Compruebe el enlace o solicite una nueva invitación.',
  invitationAccepted: 'La invitación fue aceptada correctamente. ¡Bienvenido a bordo!',
  unknownError: '¡Vaya! Algo salió mal',
  conflictEmailOrPhone: 'El correo electrónico o número de teléfono ya está en uso por otro moderador',
  signupTitle: '¡Súmate a tu equipo!',
  submitBtn: 'Unirme ahora',
  signupSuccessful: '¡Se ha suscrito correctamente a Moovex!',
  signupFailed: 'Algo salió mal Intente de nuevo o comuníquese con michael@moovex.com',
  backToLogin: 'Continuar para iniciar sesión',
  phoneInvalid: 'El número de teléfono no es válido.',
  firstName: 'Nombre',
  lastName: 'Apellido',
  phone: 'Telefono',
  email: 'Correo electrónico',
  createPassword: 'Crear contraseña',
  confirmPassword: 'Confirme la contraseña',
  success: {
    redirectIn: 'Será redirigido a ',
    seconds: ' segundos',
  },
};

export default signup;
